export const Color = {
	YELLOW: '#fce746',
	LIGHT_BLUE: '#5bb4ea',
	PURPLE: '#c40079',
	PINK: '#e8bdd7',
	ORANGE: '#d37523',
	RED: '#c20e1a',
	DARK_BLUE: '#192e59',
	// TODO Get actual green color
	GREEN: '#d3d727',
};

export const APP_NAME = 'Money Saving Hub';

export const EMAIL_SERVER_HOST = process.env.EMAIL_SERVER_HOST;
export const EMAIL_SERVER_PORT = process.env.EMAIL_SERVER_PORT !== undefined
	? parseInt(process.env.EMAIL_SERVER_PORT)
	: undefined;
export const EMAIL_SERVER_USER = process.env.EMAIL_SERVER_USER;
export const EMAIL_SERVER_PASSWORD = process.env.EMAIL_SERVER_PASSWORD;
export const EMAIL_FROM_ADDRESS = process.env.EMAIL_SERVER_FROM_ADDRESS;

export const ADMIN_EMAIL = 'tufan@tufan.co.uk';
export const INITIAL_ROUTE = '/';

export const Route = {
	capaPerformance: '/',
	providers: '/providers',
	compare: '/compare',
	report: '/report',
	adminUsers: '/admin/users',
	adminProviders: '/admin/providers',
	account: '/account',
	about: '/about',
	consumers: '/consumers',
	why: '/why',
	upgrade: '/upgrade',
	quarterlyUpdates: '/quarterly_updates',
	research: '/research',
};
